interface WidgetContactItemProps {
  iconClass: string;
  label: string;
  title: string;
  tel1?: string | null;
  tel2?: string | null;
  visible?: boolean;
}

const WidgetContactItem: React.FC<WidgetContactItemProps> = ({
  iconClass,
  label,
  title,
  tel1,
  tel2,
  visible = true,
}) => {
  if (!visible || (!tel1 && !tel2)) return null;

  return (
    <div className="d-flex mb-3">
      <div className="contact-address-icon">
        <i className={`${iconClass} text-primary font-xlll`}></i>
      </div>
      <div className="ml-3">
        <h6>{label}</h6>
        <p>
          {tel1 && (
            <a href={`tel:${tel1}`} title={title}>
              {tel1}
            </a>
          )}
          {tel2 && (
            <>
              {" | "}
              <a href={`tel:${tel2}`} title={title}>
                {tel2}
              </a>
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default WidgetContactItem;